import artikelApi from "@/api/artikler";
import DOMPurify from "dompurify";
import styles from "./Artikel.module.scss";
import { useQuery } from "@tanstack/react-query";

export default function ArtikelVisning(props: IArtikelProps) {
  const { artikelId } = props;

  const { data, isFetching, isError } = useQuery<{
    titel: string;
    indhold: any;
  }>({
    queryKey: ["artikel", artikelId],
    queryFn: async () => {
      return await artikelApi.getArtikelFromId(artikelId);
    },
    refetchOnWindowFocus: false,
  });

  if (isFetching) {
    return <div className={styles.container}>Henter artikel ...</div>;
  }
  if (isError) {
    return (
      <div className={styles.container}>
        Noget gik galt ved henting af artikel.
      </div>
    );
  }
  if (!isFetching && data) {
    const { titel, indhold } = data;
    return (
      <div className={styles.container}>
        <h1>{titel}</h1>
        <article
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(indhold) }}
        ></article>
      </div>
    );
  }
  return null;
}

interface IArtikelProps {
  artikelId: string;
}
